import {
  ACT_TEST_TYPE,
  GMAT_TEST_TYPE,
  GRE_TEST_TYPE,
  MCAT_TEST_TYPE,
  SAT_TEST_TYPE,
} from "utils/constants";

/**
 * Gets the display name for office hours based on test type.
 * Ported from C# _getOfficeHoursDisplayName method in TopicFocusController.
 *
 * @param testType - The test type (e.g., "MCAT", "SAT", "ACT", "GMAT", "GRE")
 * @param dontShowTestType - If true, omits the test type prefix (default: false)
 * @param isLiveAdmissions - If true and test type is MCAT, returns "Admissions Advantage" (default: false)
 * @returns The display name for office hours
 */
export const getOfficeHoursDisplayName = (
  testType: string,
  dontShowTestType: boolean = false,
  isLiveAdmissions: boolean = false
): string => {
  switch (testType) {
    case SAT_TEST_TYPE:
      return dontShowTestType ? "Advantage" : "SAT Advantage";

    case ACT_TEST_TYPE:
      return dontShowTestType ? "Advantage" : "ACT Advantage";

    case GMAT_TEST_TYPE:
      return dontShowTestType ? "Explanation" : "GMAT Explanation";

    case GRE_TEST_TYPE:
      return "Math Fundamentals";

    case MCAT_TEST_TYPE:
      if (isLiveAdmissions) {
        return "Admissions Advantage";
      } else {
        return "Topic Focus";
      }

    default:
      return "Office Hours";
  }
};
